
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/profile/addresses/collection",
      function () {
        return require("private-next-pages/[locale]/profile/addresses/collection.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/profile/addresses/collection"])
      });
    }
  